// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"2a74059f","453":"68d2f560","667":"288dbb68","977":"b7ddcb23"}[chunkId] + ".chunk.js";
};